




















import {Component, Prop, Vue} from 'vue-property-decorator';
import {mixin as clickaway} from 'vue-clickaway';
import {ConditionViewModel} from './models/conditionViewModel';
import {ConditionPickerOption} from './models/conditions';
import ConditionPicker from './ConditionPicker.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';

@Component({
	mixins: [
		clickaway,
	],
	components: {
		AddIcon,
		ConditionPicker
	}
})
export default class AddCondition extends Vue {
	@Prop() public availableConditions: ConditionPickerOption[];
	@Prop({default: false}) public disabled: boolean;
	@Prop() public tooltip: string;

	public isConditionPickerOpen = false;

	public openNewConditionPicker() {
		if (this.disabled) {
			return;
		}

		this.isConditionPickerOpen = true;
	}

	public closeNewConditionPicker() {
		this.isConditionPickerOpen = false;
	}

	public onConditionAdded(condition: ConditionViewModel) {
		this.closeNewConditionPicker();
		this.$emit('added', condition);
	}
}
